var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "camera-chart" },
    [
      _c(
        "a-row",
        { attrs: { gutter: 24 } },
        [
          _c(
            "a-col",
            { attrs: { sm: 24, md: 12, lg: 12, xl: 12 } },
            [
              _c(
                "a-card",
                { staticClass: "card-item", attrs: { loading: _vm.loading } },
                [
                  _c(
                    "a-row",
                    { staticStyle: { "margin-top": "10px" } },
                    [
                      _c(
                        "a-col",
                        { attrs: { span: 8 } },
                        [
                          _c("a-statistic", {
                            attrs: {
                              title: "学生总数",
                              value: _vm.total.studentCount,
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "a-col",
                        { attrs: { span: 8 } },
                        [
                          _c("a-statistic", {
                            attrs: {
                              title: "人脸录入数",
                              value: _vm.total.studentFaceCount,
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "a-col",
                        { attrs: { span: 8 } },
                        [
                          _c("a-statistic", {
                            attrs: {
                              title: "抓拍覆盖率",
                              precision: 2,
                              value: _vm.total.cameraStudentFaceCount
                                ? (_vm.total.cameraStudentFaceCount /
                                    _vm.total.studentFaceCount) *
                                  100
                                : 0,
                              suffix: "%",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-row",
                    { staticStyle: { "margin-top": "30px" } },
                    [
                      _c(
                        "a-col",
                        { attrs: { span: 8 } },
                        [
                          _c("a-statistic", {
                            attrs: {
                              title: "情绪识别次数",
                              value: _vm.total.cameraFaceCount,
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "a-col",
                        { attrs: { span: 8 } },
                        [
                          _c("a-statistic", {
                            attrs: {
                              title: "提醒人次",
                              value: _vm.total.warnCount,
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "a-col",
                        { attrs: { span: 8 } },
                        [
                          _c("a-statistic", {
                            attrs: {
                              title: "家长访问次数",
                              value: _vm.total.visitCount,
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "a-col",
            { attrs: { sm: 24, md: 12, lg: 12, xl: 12 } },
            [
              _c(
                "a-card",
                { staticClass: "card-item", attrs: { loading: _vm.loading } },
                [
                  _c("div", { staticClass: "flex-align-center" }, [
                    _c("span", { staticStyle: { "margin-right": "5px" } }, [
                      _vm._v("今日相机采集量"),
                    ]),
                    _c(
                      "span",
                      {
                        staticClass: "title-1",
                        staticStyle: { "font-size": "22px" },
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.chartData.todayStudentFaceCount) +
                            "\n          "
                        ),
                      ]
                    ),
                  ]),
                  _c("mini-area", {
                    attrs: {
                      "data-source": _vm.chartData.studentFaceList,
                      chartConfig: {
                        height: 200,
                        padding: [40, 40, 40, 40],
                      },
                      showXAxis: true,
                      y: "相机采集量",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "a-col",
            { attrs: { sm: 24, md: 12, lg: 12, xl: 12 } },
            [
              _c(
                "a-card",
                { staticClass: "card-item", attrs: { loading: _vm.loading } },
                [
                  _c("div", { staticClass: "flex-align-center" }, [
                    _c("span", { staticStyle: { "margin-right": "5px" } }, [
                      _vm._v("今日消息推送量"),
                    ]),
                    _c(
                      "span",
                      {
                        staticClass: "title-1",
                        staticStyle: { "font-size": "22px" },
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.chartData.todaySmsPushCount) +
                            "\n          "
                        ),
                      ]
                    ),
                  ]),
                  _c("mini-area", {
                    attrs: {
                      "data-source": _vm.chartData.smsPushList,
                      chartConfig: {
                        height: 200,
                        padding: [40, 40, 40, 40],
                      },
                      showXAxis: true,
                      y: "消息推送量",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "a-col",
            { attrs: { sm: 24, md: 12, lg: 12, xl: 12 } },
            [
              _c(
                "a-card",
                { staticClass: "card-item", attrs: { loading: _vm.loading } },
                [
                  _c("div", { staticClass: "flex-align-center" }, [
                    _c("span", { staticStyle: { "margin-right": "5px" } }, [
                      _vm._v("今日抓拍学生量"),
                    ]),
                    _c(
                      "span",
                      {
                        staticClass: "title-1",
                        staticStyle: { "font-size": "22px" },
                      },
                      [_vm._v(_vm._s(_vm.chartData.todayStudentCount))]
                    ),
                  ]),
                  _c("mini-area", {
                    attrs: {
                      dataSource: _vm.chartData.studentList,
                      chartConfig: {
                        height: 200,
                        padding: [40, 40, 40, 40],
                      },
                      showXAxis: true,
                      y: "抓拍学生量",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "a-card",
        {
          attrs: {
            loading: _vm.loading,
            bordered: false,
            "body-style": { padding: "0" },
          },
        },
        [
          _c(
            "div",
            { staticClass: "salesCard" },
            [
              _c(
                "div",
                {
                  staticClass: "extra-wrapper",
                  attrs: { slot: "tabBarExtraContent" },
                  slot: "tabBarExtraContent",
                },
                [
                  _c(
                    "div",
                    { staticClass: "extra-item" },
                    [
                      _c(
                        "a-button",
                        {
                          attrs: {
                            type: _vm.rangeType === "today" ? "primary" : "",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.changeRangeType("today")
                            },
                          },
                        },
                        [_vm._v("\n            今日\n          ")]
                      ),
                      _c(
                        "a-button",
                        {
                          attrs: {
                            type: _vm.rangeType === "week" ? "primary" : "",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.changeRangeType("week")
                            },
                          },
                        },
                        [_vm._v("\n            近7天\n          ")]
                      ),
                      _c(
                        "a-button",
                        {
                          attrs: {
                            type: _vm.rangeType === "month" ? "primary" : "",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.changeRangeType("month")
                            },
                          },
                        },
                        [_vm._v("\n            近30天\n          ")]
                      ),
                    ],
                    1
                  ),
                  _c("a-range-picker", {
                    style: { width: "256px" },
                    attrs: { value: _vm.rangeDate },
                    on: { change: _vm.onRangeChange },
                  }),
                ],
                1
              ),
              _c(
                "a-tabs",
                {
                  attrs: {
                    "default-active-key": "1",
                    size: "large",
                    "tab-bar-style": {
                      marginBottom: "24px",
                      paddingLeft: "16px",
                    },
                  },
                },
                [
                  _c(
                    "a-tab-pane",
                    {
                      key: "1",
                      attrs: { loading: "true", tab: "相机采集统计" },
                    },
                    [
                      _c(
                        "a-row",
                        [
                          _c(
                            "a-col",
                            {
                              attrs: { xl: 18, lg: 12, md: 12, sm: 24, xs: 24 },
                            },
                            [
                              _c(
                                "EmptyData",
                                {
                                  attrs: {
                                    dataSource: _vm.cameraData,
                                    styleObj: { marginTop: "50px" },
                                  },
                                },
                                [
                                  _c("line-chart-multid", {
                                    attrs: {
                                      slot: "content",
                                      title: "相机采集统计",
                                      height: 500,
                                      fields: _vm.cameraDataFields,
                                      dataSource: _vm.cameraData,
                                    },
                                    slot: "content",
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "a-col",
                            {
                              attrs: { xl: 6, lg: 12, md: 12, sm: 24, xs: 24 },
                            },
                            [
                              _c("rank-list", {
                                attrs: {
                                  height: 500,
                                  title: "各相机采集总数(覆盖人数)",
                                  list: _vm.cameraRankList,
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-tab-pane",
                    { key: "2", attrs: { tab: "学生采集统计" } },
                    [
                      _c(
                        "a-row",
                        [
                          _c(
                            "a-col",
                            {
                              attrs: { xl: 18, lg: 12, md: 12, sm: 24, xs: 24 },
                            },
                            [
                              _c(
                                "EmptyData",
                                {
                                  attrs: {
                                    dataSource: _vm.studentFaceData,
                                    styleObj: { marginTop: "50px" },
                                  },
                                },
                                [
                                  _c("line-chart-multid", {
                                    attrs: {
                                      slot: "content",
                                      height: 500,
                                      title: _vm.studentFaceDataTitle,
                                      fields: _vm.studentFaceDataFields,
                                      dataSource: _vm.studentFaceData,
                                      showReturnBtn:
                                        _vm.studentFaceDataLevel === 2,
                                    },
                                    on: {
                                      click: _vm.studentFaceDataClick,
                                      return: _vm.studentFaceDataReturn,
                                    },
                                    slot: "content",
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "a-col",
                            {
                              attrs: { xl: 6, lg: 12, md: 12, sm: 24, xs: 24 },
                            },
                            [
                              _c("rank-list", {
                                attrs: {
                                  height: 500,
                                  title: "人脸采集总数(覆盖人数)",
                                  list: _vm.studentFaceRankList,
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-tab-pane",
                    { key: "3", attrs: { tab: "消息推送统计" } },
                    [
                      _c(
                        "a-row",
                        [
                          _c(
                            "a-col",
                            {
                              attrs: { xl: 18, lg: 12, md: 12, sm: 24, xs: 24 },
                            },
                            [
                              _c(
                                "EmptyData",
                                {
                                  attrs: {
                                    dataSource: _vm.smsPushData,
                                    styleObj: { marginTop: "50px" },
                                  },
                                },
                                [
                                  _c("line-chart-multid", {
                                    attrs: {
                                      slot: "content",
                                      height: 500,
                                      title: _vm.smsPushDataTitle,
                                      fields: _vm.smsPushDataFields,
                                      dataSource: _vm.smsPushData,
                                      showReturnBtn: _vm.smsPushDataLevel === 2,
                                    },
                                    on: {
                                      click: _vm.smsPushDataClick,
                                      return: _vm.smsPushDataReturn,
                                    },
                                    slot: "content",
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "a-col",
                            {
                              attrs: { xl: 6, lg: 12, md: 12, sm: 24, xs: 24 },
                            },
                            [
                              _c("rank-list", {
                                attrs: {
                                  height: 500,
                                  title: "消息推送总数(覆盖人数)",
                                  list: _vm.smsPushRankList,
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm.isShowParentVisit
                    ? _c(
                        "a-tab-pane",
                        { key: "5", attrs: { tab: "家长访问统计" } },
                        [
                          _c(
                            "a-row",
                            [
                              _c(
                                "a-col",
                                {
                                  attrs: {
                                    xl: 18,
                                    lg: 12,
                                    md: 12,
                                    sm: 24,
                                    xs: 24,
                                  },
                                },
                                [
                                  _c(
                                    "EmptyData",
                                    {
                                      attrs: {
                                        dataSource: _vm.parentVisitData,
                                        styleObj: { marginTop: "50px" },
                                      },
                                    },
                                    [
                                      _c("line-chart-multid", {
                                        attrs: {
                                          slot: "content",
                                          height: 500,
                                          title: _vm.parentVisitDataTitle,
                                          fields: _vm.parentVisitDataFields,
                                          dataSource: _vm.parentVisitData,
                                          showReturnBtn:
                                            _vm.parentVisitDataLevel === 2,
                                        },
                                        on: {
                                          click: _vm.parentVisitDataClick,
                                          return: _vm.parentVisitDataReturn,
                                        },
                                        slot: "content",
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "a-col",
                                {
                                  attrs: {
                                    xl: 6,
                                    lg: 12,
                                    md: 12,
                                    sm: 24,
                                    xs: 24,
                                  },
                                },
                                [
                                  _c("rank-list", {
                                    attrs: {
                                      height: 500,
                                      title:
                                        "家长访问总数(覆盖人数),关爱名单访问总数(覆盖人数)",
                                      list: _vm.parentVisitRankList,
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
      _c("div", { staticStyle: { height: "20px" } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }